import { useTranslation } from 'react-i18next'
import _ from 'lodash'

import { Dropdown } from '@/components/componentLibrary'
import { SpatialPolicy as Policy } from '@/models/spatialPolicy'
import { applyCitywideOption, getCitywideLayerName } from '@/modules/layers/constants'
import { useAvailableLayerOptions } from '@/modules/layers/queries'

import { HideableField, SelectionTags } from './components'
import { EditableFieldProps } from './types'

const SHAPE_LAYER_TITLE = 'Associated Geography'

export const ShapeLayerUUID = ({ policy, ...props }: { policy: Policy }) => {
  const { t } = useTranslation()

  return (
    <HideableField
      titleText={t('policiesLibrary.formGeographyTitle', SHAPE_LAYER_TITLE)}
      {...props}
    >
      {policy.isEntireRegion ? (
        <SelectionTags values={[getCitywideLayerName()]} />
      ) : policy.shapeLayerName ? (
        <SelectionTags values={[policy.shapeLayerName]} />
      ) : null}
    </HideableField>
  )
}

export const EditableShapeLayerUUID = ({
  editable,
  editPolicy,
  onValidate,
  policy,
  ...props
}: EditableFieldProps) => {
  const { t } = useTranslation()
  const shapeLayerOptions = applyCitywideOption(
    useAvailableLayerOptions(),
    policy.optionalEntireRegion
  )

  return editable ? (
    <HideableField
      editable
      titleText={t('policiesLibrary.formGeographyTitle', SHAPE_LAYER_TITLE)}
      {...props}
    >
      {policy.isEntireRegion ? (
        <SelectionTags values={[getCitywideLayerName()]} />
      ) : (
        <Dropdown
          error={props.error}
          name="shapeLayerUUID"
          onBlur={onValidate}
          onChange={uuid =>
            !_.isArray(uuid) && editPolicy?.(p => p.setShapeLayerUuid(uuid || null))
          }
          options={shapeLayerOptions}
          placeholder={t(
            'policiesLibrary.formGeographyPlaceholder',
            'Define where the policy applies'
          )}
          value={policy.shapeLayerUUID || undefined}
        />
      )}
    </HideableField>
  ) : (
    <ShapeLayerUUID policy={policy} {...props} />
  )
}
